<template>
  <div
    v-if="site"
    class="mb-3 flex items-center rounded-lg bg-white p-6 shadow">
    <div class="mr-4">
      <font-awesome-icon
        class="text-core-500"
        icon="map-marker-alt"
        size="3x" />
    </div>
    <div class="flex-grow">
      <div
        v-if="site.denomination"
        class="font-bold uppercase">
        {{ site.denomination }}
      </div>
      <div
        v-if="site.numeroVoie"
        class="text-sm uppercase">
        {{ site.numeroVoie }}
      </div>
      <div
        v-if="site.codePostal && site.ville"
        class="text-sm uppercase">
        {{ `${site.codePostal} ${site.ville}` }}
      </div>
    </div>
    <div
      v-if="site.coordinates"
      v-on:click="openMapModal"
      v-tooltip.top="`Consulter l'emplacement sur une carte dynamique`"
      class="group flex h-16 w-16 cursor-pointer items-center justify-center rounded-full bg-jinius-blue shadow-sm transition-colors hover:bg-jinius-dark-green">
      <font-awesome-icon
        class="pb-1 text-white"
        icon="map-marked-alt"
        size="2x" />
    </div>
  </div>
  <details-map-modal
    v-if="!loading && site && site.coordinates"
    v-on:onclose="closeMapModal"
    v-bind:modal_show="map_modal"
    v-bind:coordinates="site.coordinates.split(',')"
    v-bind:adresse="concatAdresse(site)" />
</template>

<script>
  import detailsMapModal from '@/views/_espace/details-map-modal.vue';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

  export default {
    name: 'session-site-info',
    components: {
      FontAwesomeIcon,
      detailsMapModal
    },
    props: {
      site: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        map_modal: false
      };
    },
    methods: {
      openMapModal(e) {
        e?.preventDefault();
        this.map_modal = true;
      },
      closeMapModal() {
        this.map_modal = false;
      },
      concatAdresse(site) {
        const { numeroVoie = '', codePostal = '', ville = '' } = site;
        return `${numeroVoie} ${codePostal} ${ville}`.trim();
      }
    }
  };
</script>
